import { i18n } from "@/i18n";

export default {
  path: "/redirected-route",
  name: "redirectedRoute",
  component: () => import(/* webpackChunkName: "redirected-route" */ "@/views/RedirectedRoute/RedirectedRoute.vue"),
  meta: {
    authRequired: false,
    title: i18n.global.t("dashboard.welcome_to_studea"),
    breadcrumb: false,
  },
};
